export default __webpack_public_path__ + "static/media/PMS-Tree.e9efc17f.svg";